export default `---
slug: happy-customers
title: "Happy Customers"
year: 2023
category: personal
featured: false
tags: [Python, XGBoost, Classification, Scikit-learn, Apziva]
thumbnail: /images/projects/13_vecho_learning.png
description: "Binary classification to predict customer happiness — my first Apziva project, and a deep dive into XGBoost hyperparameter tuning."
relatedLinks:
  - label: "Apziva Data Science Bootcamp"
    href: /career/apziva-bootcamp
---

This is the first project I did with [Apziva](https://www.apziva.com/), a Data Science bootcamp that I attended for the most part of 2023.
Apziva provided me the dataset for the project, and a mentor whom I would have weekly meetings with, to support my progress. Except for Bhargav (my mentor), I did everything alone, *and with ChatGPT, who am I kidding*.

This project ([GitHub repo](https://github.com/Ilvecho/Happy-Customers)) was a Binary Classification problem, in which we had to predict whether a customer would be happy or not based on their feedback survey answers.

![Student in NL doing XGBoost](/images/projects/13_vecho_learning.png)

The first thing we do is a **dataset analysis**:

- **Missing values & outliers:** no missing values, and no outliers
- **Balance analysis:** the dataset is fairly balanced, so no correcting actions need to be taken
- **Correlation:** we notice that there is a weak correlation between X2 and Y, as well as X2 and all the other features. We could consider excluding X2 from the dataset features
- We also perform a **Classed based analysis:** we extract some interesting insight, but nothing useful in the development of the classifier

Then, for didactic reasons, we tried **different models** (using the default parameters) to understand the main differences between them:

- Decision tree
- Random forest
- Gradient boosting
- XGBoost
- LightGBM

LightGBM is by far the fastest, while XGBoost performs the best in terms of accuracy. Since we are working with a (very) small dataset, computational speed is not so relevant, hence we decide the use XGBoost and tune its parameters.

We use Grid Search CV to perform the tuning, and we focus on:

- max_depth
- subsample
- reg_lambda
- reg_alpha
- colsample_bytree
- min_child_weight
- n_estimators
- learning_rate

Note that we include all the default values in the grid. We perform 3 iterations of tuning, and we observe a drop in training accuracy, which is due the regularization to avoid overfitting, and an increase in the validation accuracy - which means that the tuning is working.
Once we find the optimal parameters, we create a model using them, and test it on the test set (not used in the tuning). During the model iterations, we see the log loss decreasing, which means that the newly added trees are improving the performance of the model.
However, once the training is over and we calculate the predictions, we observe a **worsening in the test performance** both with respect to the validation accuracy and the default model test accuracy. Furthermore, the tuned model performs worse than the default model also in terms of confusion matrix, ROC score and AUC.
These results could be explain thinking about the fact that the available dataset is extremely small. Also, looking at the feature importances, we notice that the model is not using X2, and very mildly using X4, X5 and X6. Hence, on top of the limited number of samples, also the number of relevant features is limited, reducing a lot the data available to train the model.

This project was coded in Python, using the most common libraries for data science: numpy, pandas, matplotlib, seaborn, scikit-learn.
`;
